import React from 'react';

function SectionHeader({ children, style }) {
  return (
    <div style={{ fontFamily: "'Cinzel', serif", fontSize: "18px", color: "#c9a84c", marginBottom: 16, textAlign: "center", letterSpacing: "2px", ...style }}>
      {children}
      <div style={{ width: 60, height: 1, background: "linear-gradient(90deg, transparent, #c9a84c, transparent)", margin: "8px auto 0" }} />
    </div>
  );
}

export default SectionHeader;
